import React from "react";
import { useSelector } from "react-redux";

const Preloader = () => {
  const loading = useSelector(state => Object.values(state.loading).some(status => status)); // Check if any API is loading
  const error = useSelector(state => Object.values(state.error).some(err => err)); // Check if any API has an error

  return (
    <>
      {loading && (
        <div className="preloader">
          <img src="assets/images/icon/preloader.gif" alt="Loading..." />
        </div>
      )}

      {error && (
        <div className="preloader">
          <img src="assets/images/icon/server_down.gif" alt="Error!" />
          <p>Oops! Something went wrong.</p>
        </div>
      )}
    </>
  );
};

export default Preloader;
